import Relay from 'react-relay';

export default {
  viewer: (Component) => Relay.QL`query { viewer { ${Component.getFragment('viewer')} } }`,
};


// WEBPACK FOOTER //
// ./src/queries/CirclesListQueries.js